import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Chapters from "@/components/landing/Chapters";
import Offers from "@/components/landing/Offers";
import Founder from "@/components/landing/Founder";
import Testimonials from "@/components/landing/Testimonials";
import Connect from "@/components/landing/Connect";
import Footer from "@/components/landing/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-[#0A0F08] text-[#F2F1E8] min-h-screen">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Chapters />
        <Offers />
        <Founder />
        <Testimonials />
        <Connect />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
